import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deleteIntegrationItemGroup = (
    token: string,
    backend: string,
    id: any,
) => {
    return fetch(
        `${getApiUrl(backend)}integrationItemGroups/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteIntegrationItemGroup;